import { InputPadrao, InputSwitch } from '../../../../components/Inputs'
import React, { useState, useEffect } from 'react'
import { Formik, Form } from "formik"
import { mostrarToast } from '../../../../components/Toasts'
import { BotaoPadrao } from '../../../../components/Botoes'
import { get, getComAuditoria, salvar } from '../../../../util/AcessoApi'
import { Link, useParams } from "react-router-dom"
import { mensagens } from '../../../../util/Utilitarios'
import Yup from '../../../../util/Validacoes'
import '../../../../assets/css/ios-switch/clean-switch.css'
import 'react-circular-progressbar/dist/styles.css'
import 'react-toastify/dist/ReactToastify.css'
import 'bootstrap/dist/css/bootstrap.min.css'
import Atalho from '../../../../util/Atalho'
import { HeaderCadastro } from '../../../../components/Headers'
import { InputTipoDocumentoSocio } from '../../../../components/InputsAutoCompleteV2'
import { MODULO } from '../../../../util/Enums'
import InputArquivoS3 from '../../../../components/InputArquivoS3V2'
import { ModalDuasOpcoes } from '../../../../components/Modais'

const CadastroSocioDocumento = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [dataArquivos, setDataArquivos] = useState(null)
    const [limparArquivos, setLimparArquivos] = useState(false)
    const [showModalValidacao, setShowModalValidacao] = useState(false)
    const [mensagemModal, setMensagemModal] = useState('')

    const [validacao] = useState(Yup.object({
        tipo_documento: Yup.object().required().nullable(),
        descricao: Yup.string()
            .required().nullable().trim()
            .max(200)
    }))

    const manter = []

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        values.arquivo = dataArquivos

        salvar(
            values,
            '/administracao/sociodocumento',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)
                if (salvarENovo) {
                    propsFormik.resetForm({})
                    // manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                    setSalvarENovo(false)
                }
                else
                    props.history.push('/administracao/socio-documento/consulta')

                setSalvando(false)
            }, (err) => {
                console.log('err: ', err);
                mostrarToast('erro', mensagens.erro)
                setSalvando(false)
            })
    }


    useEffect(_ => {
        if (!props.modal && id) {

            Promise.resolve(getComAuditoria(`/administracao/sociodocumento/${id}`, { modulo: MODULO['/administracao/sociodocumento/'], id: id })).then(obj => {
                setDataArquivos([...obj.arquivo] || [])
                setValoresIniciais(obj)
            })
        } else {
            setDataArquivos([])
            setValoresIniciais({
                descricao: '',
                tipo_documento: '',

            })
        }
    }, [id])

    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <span>Administrativo</span>,
        () => <Link className='link-active' to={'/administracao/socio-documento/consulta'}>Sócio Documento</Link>,
    ]

    const validarSubmit = async (values, propsFormik) => {

        if (dataArquivos == null || dataArquivos == undefined || dataArquivos.length == 0) {
            setMensagemModal(`Registro não possui documento(s) anexado. Deseja continuar?`)
            setShowModalValidacao(true)
        } else {
            Submit(values, propsFormik)
        }
    }


    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => validarSubmit(values, propsFormik)}>
            {propsFormik => (<Form>
                {!props.modal && <HeaderCadastro titulo={"Cadastro Sócio Documentos"} link={links} />}
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={'card-body'}>
                        <div className='row'>
                            {/* <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' obrigatorio={false} /> */}
                            <InputPadrao autoFocus label='Descrição' name='descricao' type='text' placeholder='Descrição' obrigatorio={true} tamanho='col-7 col-xl-7 col-sm-12' salvarENovo={salvarENovo} />
                            <InputTipoDocumentoSocio botaoVisivel botaoAlterar label="Tipo Documento" name="tipo_documento" placeholder="Tipo Documento" obrigatorio propsFormik={propsFormik} tamanho="col-xl-5 col-lg-5" />


                        </div>
                    </div>
                </div>
                <div className="mt-40">
                    <HeaderCadastro
                        titulo={'Anexar Arquivos'}
                        classeChildren='space-between-100' >
                    </HeaderCadastro>
                </div>
                <div className="card mb-20">
                    <div className="card-body">
                        {dataArquivos != null ?
                            <InputArquivoS3
                                name='arquivo'
                                placeholder='Arquivo'
                                tamanho='col-12'
                                diretorioS3='socio-documento/DDMMYYYY/'
                                modulo={MODULO["/administracao/sociodocumento"]}
                                tamanhoMinimo={0}
                                tamanhoMaximoEmMB={300}
                                setDataArquivos={setDataArquivos}
                                dataArquivos={dataArquivos != null ? dataArquivos : []}
                                setIsSubmit={dataArquivos.length > 0 ? setSalvando : () => { }}
                                limparCampos={limparArquivos}
                            /> : <></>}
                    </div>
                </div>
                {!props.modal && <div className='separator mt-40 mb-5'></div>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {(props.modal || !id) && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}

                </div>
                <ModalDuasOpcoes showModal={showModalValidacao} setShowModal={setShowModalValidacao} funcaoOpcao2={() => { Submit(propsFormik.values, propsFormik); setShowModalValidacao(false) }} funcaoOpcao1={() => { setSalvando(false); setShowModalValidacao(false) }}
                    esconderFechar mensagem={mensagemModal}
                    textoOpcao1={'Cancelar'}
                    classeOpcao1={'btn-sm btn-primary-modal simples'}
                    textoOpcao2={'Continuar'} />

            </Form>)}
        </Formik>
    );
}

export default CadastroSocioDocumento 
